"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PublishModal = void 0;
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const Button_1 = require("../button/Button");
const Modal_1 = require("../modal/Modal");
const PagesAndFlows_1 = require("./PagesAndFlows");
const StyleWrapper = styled_1.default.div `
	max-height: 30%;
`;
const buildModalButtons = (page, publishing, next, prev, publish, close, failHelp, requirePropertyVerification, complete) => {
    const btnNext = (React.createElement(Button_1.Button, { buttonType: Button_1.PresetThemes.Primary, onClick: next }, "Next"));
    const btnPrev = React.createElement(Button_1.Button, { onClick: prev }, "Previous");
    if (page === PagesAndFlows_1.componentsMap.Intro) {
        return { actionRHS: btnNext };
    }
    else if (page === PagesAndFlows_1.componentsMap.InfoOne) {
        return {
            actionLHS: btnPrev,
            actionRHS: (React.createElement(Button_1.Button, { buttonType: Button_1.PresetThemes.Primary, onClick: next }, "Accept instant book")),
        };
    }
    else if (page === PagesAndFlows_1.componentsMap.InfoTwo) {
        return {
            actionLHS: btnPrev,
            actionRHS: (React.createElement(Button_1.Button, { buttonType: Button_1.PresetThemes.Primary, onClick: next }, "Accept calendar terms")),
        };
    }
    else if (page === PagesAndFlows_1.componentsMap.InfoThree) {
        return {
            actionLHS: btnPrev,
            actionRHS: (React.createElement(Button_1.Button, { buttonType: Button_1.PresetThemes.Primary, onClick: next }, "Accept iCal terms")),
        };
    }
    else if (page === PagesAndFlows_1.componentsMap.Publish) {
        return {
            actionLHS: btnPrev,
            actionRHS: (React.createElement(Button_1.Button, { loading: publishing, buttonType: Button_1.PresetThemes.Primary, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                    yield publish();
                    next();
                }) }, "Publish now")),
        };
    }
    else if (page === PagesAndFlows_1.componentsMap.VerificationPending) {
        return {
            actionRHS: (React.createElement(Button_1.Button, { loading: false, buttonType: Button_1.PresetThemes.Primary, onClick: complete }, "Done")),
        };
    }
    else if (page === PagesAndFlows_1.componentsMap.Short) {
        return {
            actionRHS: (React.createElement(Button_1.Button, { loading: publishing, buttonType: Button_1.PresetThemes.Primary, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                    if (requirePropertyVerification) {
                        yield publish();
                        next();
                    }
                    else {
                        yield publish();
                        complete();
                    }
                }) }, "Publish now")),
        };
    }
    else if (page === PagesAndFlows_1.componentsMap.Failed) {
        return {
            actionLHS: React.createElement(Button_1.Button, { onClick: failHelp }, "Get help"),
            actionRHS: (React.createElement(Button_1.Button, { buttonType: Button_1.PresetThemes.Primary, onClick: close }, "Try again")),
        };
    }
    else {
        return { actionLHS: btnPrev, actionRHS: btnNext };
    }
};
const PublishModal = (props) => {
    // Define which flow
    let flow = PagesAndFlows_1.longFlow;
    if (props.short) {
        if (props.requirePropertyVerification) {
            flow = PagesAndFlows_1.shortAndVerifyFlow;
        }
        else {
            flow = PagesAndFlows_1.shortFlow;
        }
    }
    const [currentPageIndex, setCurrentPageIndex] = React.useState(0);
    const currentPage = flow[currentPageIndex];
    const [publishing, setPublishing] = React.useState(false);
    const onNextPageTap = () => {
        setCurrentPageIndex((prev) => prev + 1);
    };
    const onPrevPageTap = () => {
        setCurrentPageIndex((prev) => prev - 1);
    };
    const handlePublish = () => __awaiter(void 0, void 0, void 0, function* () {
        setPublishing(true);
        const result = yield props.publish();
        setPublishing(false);
        if (!result) {
            // Set to the last page of the flow, which is the Failed page
            setCurrentPageIndex(flow.length - 1);
        }
    });
    const failHelp = () => {
        if (window.Intercom !== undefined) {
            // Attempt to close modal & open Intercom window
            props.onClose();
            window.Intercom('show');
        }
        else {
            // Otherwise redirect to Intercom help site
            window.location.replace('https://travelnest.freshdesk.com/support/home');
        }
    };
    const buttons = buildModalButtons(currentPage, publishing, onNextPageTap, onPrevPageTap, handlePublish, props.onClose, failHelp, props.requirePropertyVerification, props.onComplete);
    return (React.createElement(StyleWrapper, null,
        React.createElement(Modal_1.Modal, Object.assign({ title: currentPage === PagesAndFlows_1.componentsMap.VerificationPending ?
                'Property verification pending' :
                'Publish your property', onRequestClose: props.onClose }, buttons), currentPage)));
};
exports.PublishModal = PublishModal;
//# sourceMappingURL=PublishModal.js.map